import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialColorOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"
import {color} from "@cm/graph-v3"

export interface CombineRgbSockets extends MaterialNodeSockets {
    inputs: {
        b: "float" // found in inputs: -; found in settings: float; inferred from data: float
        g: "float" // found in inputs: color,float; found in settings: float; inferred from data: float
        r: "float" // found in inputs: color,float; found in settings: float; inferred from data: float
    }
    settings: {
        b: "float" // found in inputs: -; found in settings: float; inferred from data: float
        g: "float" // found in inputs: color,float; found in settings: float; inferred from data: float
        image: "color" // found in inputs: -; found in settings: color; inferred from data: float3
        r: "float" // found in inputs: color,float; found in settings: float; inferred from data: float
    }
    outputs: {
        image: "color"
    }
}

export const combineRgbDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeCombineRGB,
    },
    nodeClass: "CombineRgb",
    ui: {
        label: "Combine RGB",
        color: "#4987af",
        items: [
            {valueType: "color", label: "Image", name: "image", output: true},
            {valueType: "float", label: "R", name: "r", range: {min: 0, max: 1}, input: true, setting: true, defaultValue: 0},
            {valueType: "float", label: "G", name: "g", range: {min: 0, max: 1}, input: true, setting: true, defaultValue: 0},
            {valueType: "float", label: "B", name: "b", range: {min: 0, max: 1}, input: true, setting: true, defaultValue: 0},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({image: materialColorOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({
                r: optionalMaterialInput,
                g: optionalMaterialInput,
                b: optionalMaterialInput,
            }),
            settings: z.strictObject({
                b: z.optional(z.number()),
                g: z.optional(z.number()),
                image: z.optional(color),
                r: z.optional(z.number()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<CombineRgbSockets>
